export const FACETS_KEY = 'facets';
